export default __webpack_public_path__ + "static/media/webinar.79479628.svg";